import React, { FC } from 'react';
import { Card, Container } from '@mui/material';
import { DashboardHeader } from "../../../../UIKit/DashboardHeader";
import {TextInput} from "../../../../UIKit/TextInput";
import { useUiContext } from "../../../../UIProvider";
import { observer } from 'mobx-react-lite';
import { useMagazineCategoryCreating } from '../../presenters/useMagazineCategoryCreating';

export const MagazineCategoryCreatingView: FC = observer(() => {
    const { t } = useUiContext();
    const { magazineCategory, errors, onChange, onCreateMagazineCategory, loading } = useMagazineCategoryCreating();

    return (
        <Container>
            <DashboardHeader 
                title={t("magazineCategory.createMagazineCategory")} 
                buttonTitle={t("common.save")} 
                onPress={onCreateMagazineCategory}
            />
            <Card sx={{ p: 2, mb: 2 }}>
                <TextInput label={t('common.name')} name='name' onChange={onChange} value={magazineCategory?.name} error={errors} required />
                <TextInput label={t('common.description')} name='description' onChange={onChange} value={magazineCategory?.description} error={errors} isMultiline minRows={3} required />
            </Card>
        </Container>
    );
});
